<script>
import axios from 'axios'
import moment from 'moment'
import { navComputed, navMethods, authComputed } from '@state/helpers'
import { EventBus } from '../../../src/event-bus'
import store from '@state/store'

export default {
  data() {
    return {
      loading: false,
      render: true,
      loadingData: false,
      loadingDataNew: false,
      events: [],
      showPicker: false,
      dates: [],
      newEvents: [],
      disabled: false,
      calendarDates: [],
      selectedDate: moment().format('YYYY-MM-DD'),
      selectedItem: null,
      eventTypes: [
        { color: 'blue', name: 'Appointment' },
        { color: 'indigo', name: 'Medicine' },
        { color: 'deep-purple', name: 'Exam' },
        { color: 'cyan', name: 'Reminder' },
        { color: 'green', name: 'Excercise' },
        { color: 'orange', name: 'Operation' },
        { color: 'grey darken-1', name: 'Allergy' },
        { color: 'red', name: 'Recurring Event' },
        { color: 'VIOLET', name: 'Developer Event' },
      ],
    }
  },
  computed: {
    ...navComputed,
    ...authComputed,
  },

  methods: {
    ...navMethods,
    moment,

    cancleEvent(ev) {
      this.loading = true
      axios
        .post('/api/v1/provider/cancel_appointment/', {
          provider_id: ev.provider_id,
          availability_det_id: ev.availability_det_id,
          cancellation_notes: 'Due to some urgent call, i need to cancel',
          appointment_date: ev.appointment_date,
          is_cancel_from_provider: false,
        })
        .then((response) => {
          this.loading = false
          this.events = []
          this.updateData()
        })
        .finally(() => {
          this.loading = false
        })
    },

    updateData() {
      if (this.navDrawer) {
        this.loading = true
        axios
          .get('/api/v1/me/')
          .then((response) => {
            this.loading = false

            this.newEvents = response.data.patient_appointment_details

            this.newEvents = this.newEvents.map((meeting) => {
              const todayDate = moment().format('MM/DD/YYYY')
              const bookingDate = moment(meeting.appointment_date).format(
                'MM/DD/YYYY'
              )

              const now = moment()
                .format('hh:mm:ss')
                .toString()

              const timeString = bookingDate + ' ' + meeting.appointment_time
              const nowString = todayDate + ' ' + now
              const selectedTime = new Date(timeString).getTime()
              const currentTime = new Date(nowString).getTime()

              if (selectedTime < currentTime) {
                meeting.isInPast = true
              } else {
                meeting.isInPast = false
              }
              return meeting
            })

            this.fetch(
              this.selectedDate ? this.selectedDate : new Date(),
              moment(this.selectedDate)
                .add(10, 'days')
                .endOf('day')
                .format('YYYY-MM-DD HH:mm')
            )
            this.fetchCalendar(
              moment(this.selectedDate)
                .startOf('month')
                .format('YYYY-MM-DD HH:mm'),
              moment(this.selectedDate)
                .endOf('month')
                .format('YYYY-MM-DD HH:mm')
            )
          })
          .finally(() => {})
      }
    },

    async updateDataNextPrew() {
      this.selectedDate = store.state.calender.calenderSelectedDate
      this.loadingData = true
      this.loadingDataNew = true
      axios
        .get('/api/v1/me/')
        .then((response) => {
          localStorage.setItem('meresponse', JSON.stringify(response.data))
          this.newEvents = response.data.patient_appointment_details

          this.newEvents = this.newEvents.map((meeting) => {
            const todayDate = moment().format('MM/DD/YYYY')
            const bookingDate = moment(meeting.appointment_date).format(
              'MM/DD/YYYY'
            )
            const now = moment()
              .format('hh:mm:ss')
              .toString()

            const timeString = bookingDate + ' ' + meeting.appointment_time
            const nowString = todayDate + ' ' + now
            const selectedTime = new Date(timeString).getTime()
            const currentTime = new Date(nowString).getTime()

            if (selectedTime < currentTime) {
              meeting.isInPast = true
            } else {
              meeting.isInPast = false
            }
            return meeting
          })
          this.loadingData = false

          this.fetch(
            this.selectedDate ? this.selectedDate : new Date(),
            moment(this.selectedDate)
              .add(10, 'days')
              .endOf('day')
              .format('YYYY-MM-DD HH:mm')
          )
          this.fetchCalendar(
            moment(this.selectedDate)
              .startOf('month')
              .format('YYYY-MM-DD HH:mm'),
            moment(this.selectedDate)
              .endOf('month')
              .format('YYYY-MM-DD HH:mm')
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelAppointment(ev) {
      var data = this.events
      this.events = []
      var idx = data.findIndex(
        (x) => x.availability_det_id === ev.availability_det_id
      )
      data[idx].cancelApp = true
      this.events = data
      store.dispatch('calender/setCalenderEvents', this.events)
    },
    donotcancelAppointment(ev) {
      var data = this.events
      this.events = []
      var idx = data.findIndex(
        (x) => x.availability_det_id === ev.availability_det_id
      )
      data[idx].cancelApp = false
      this.events = data
      store.dispatch('calender/setCalenderEvents', this.events)
    },
    fetchCalendar(start, end) {
      var events = this.newEvents
      this.calendarDates = []

      events.forEach((event, index) => {
        event.type = this.getEventType('blue')

        let eventAppointmentTime
        if (moment(event.appointment_time, 'LT', true).isValid()) {
          eventAppointmentTime = moment(event.appointment_time, [
            'hh:mm A',
          ]).format('hh:mm:ss')
          event.start_time = event.appointment_date + ' ' + eventAppointmentTime
        } else {
          event.start_time =
            event.appointment_date + ' ' + event.appointment_time
        }
        event.start_time = moment(event.start_time).format(
          'YYYY-MM-DD hh:mm:ss'
        )
        if (index === 0) {
          this.calendarDates.push(moment(event.start_time).format('YYYY-MM-DD'))
        } else {
          if (
            moment(event.start_time).format('YYYY-MM-DD') !==
            this.calendarDates.at(-1)
          ) {
            this.calendarDates.push(
              moment(event.start_time).format('YYYY-MM-DD')
            )
          }
        }
      })
    },
    fetch(start, end) {
      this.events = this.newEvents
      this.dates = []
      this.events.forEach((event, index) => {
        if (
          moment(start).format('YYYY-MM-DD') ===
          moment(event.appointment_date).format('YYYY-MM-DD')
        ) {
          event.type = this.getEventType('blue')
          event.start_time =
            event.appointment_date + ' ' + event.appointment_time
          event.appointment_time = moment(event.appointment_time, [
            'h:mm A',
          ]).format('hh:mm A')

          if (index === 0) {
            this.dates.push(moment(event.start_time).format('YYYY-MM-DD'))
          } else {
            if (
              moment(event.start_time).format('YYYY-MM-DD') !==
              this.dates.at(-1)
            ) {
              this.dates.push(moment(event.start_time).format('YYYY-MM-DD'))
            }
          }
        }
      })
      store.dispatch('calender/setCalenderDatesEvents', this.dates)
      store.dispatch('calender/setCalenderEvents', this.events)
      if (this.dates[0]) this.showPicker = false
    },
    getEventType(color) {
      return this.eventTypes.find((obj) => {
        return obj.color === color
      })
    },
    changeMonth(date) {
      this.updateData()
    },
    prevDay() {
      this.selectedDate = moment(this.selectedDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD')
      this.updateData()
    },
    nextDay() {
      this.selectedDate = moment(this.selectedDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
      this.updateData()
    },
    today() {
      this.selectedDate = moment().format('YYYY-MM-DD')
      this.updateData()
    },
    changeDate(start) {
      store.dispatch('calender/setCalenderSelectedDate', start)
      this.selectedDate = start
      this.updateData()
    },
    functionEvents(date) {
      if (this.calendarDates.find((c) => c === date) !== undefined) {
        return true
      } else {
        return false
      }
    },
    getDuration(s, e) {
      const start = moment(new Date(s))
      const end = moment(new Date(e))
      var duration = moment.duration(end.diff(start))
      return duration.humanize()
    },
    openInNew() {
      this.setDrawer({
        value: false,
        drawer: 'calendarDrawer',
      })
      this.$router.push({ name: 'calendar' })
    },
    changeMeetingTime(event) {
      const routeParams = {
        selectedProvider: event.provider_speciality,
        selectedProviderDetailsId: event.provider_id,
        selectedDate: event.appointment_date,
        loadDetails: true,
      }
      if (this.$router.currentRoute.name === 'safehaven-provider-list') {
        EventBus.$emit('route-pushed', routeParams)
      } else {
        this.$router.push({
          name: 'safehaven-provider-list',
          params: routeParams,
        })
      }
    },
    showEvent(event) {
      this.setDrawer({
        value: false,
        drawer: 'calendarDrawer',
      })
      if (document.getElementById('changeEventButton')) {
        document.getElementById('changeEventButton').value =
          event.availability_det_id
        document
          .getElementById('changeEventButton')
          .click({ eventId: event.availability_det_id })
      } else {
        this.$router.push({
          name: 'event-details',
          params: { eventId: event.availability_det_id },
        })
      }
    },
  },
}
</script>

<template>
  <v-container>
    <button id="updateCalneder" hidden @click="updateData"></button>
    <button id="updateCalnederNew" hidden @click="updateDataNextPrew"
      >Update</button
    >

    <v-card tile flat>
      <v-card-title>
        <div> Reminders </div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="
            setDrawer({
              value: false,
              drawer: 'calendarDrawer',
            })
          "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <v-row align="center">
          <v-col>
            <v-btn
              small
              elevation="0"
              color="transparent"
              tile
              @click="showPicker = !showPicker"
            >
              {{ moment(selectedDate).format('ll') }}
              <v-icon>{{
                showPicker ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }}</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-row align="center">
              <v-btn x-small text fab @click="prevDay">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn x-small elevation="0" @click="today"> Today </v-btn>
              <v-btn id="nextDay" x-small text fab @click="nextDay">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <transition name="fade">
      <v-date-picker
        v-show="showPicker"
        v-model="selectedDate"
        :locale="language"
        no-title
        :disabled="disabled"
        event-color="pink"
        color="primary"
        :events="functionEvents"
        @change="changeDate"
        @update:picker-date="changeMonth"
      />
    </transition>
    <v-row class="justify-center mt-5">
      <span
        v-if="
          $store.state.calender.calenderDates &&
            !$store.state.calender.calenderDates.length
        "
        >{{ $t('calendar.noEvents') }}</span
      >
    </v-row>
    <v-list
      v-for="(date, index) in $store.state.calender.calenderDates"
      :key="index"
      dense
      width="290px"
    >
      <v-subheader>{{ date }}</v-subheader>
      <v-subheader>{{ moment(date).format('dddd DD MMMM') }}</v-subheader>
      <v-list-item-group
        v-if="!disabled"
        v-model="selectedItem"
        color="primary"
        class="mx-2"
      >
        <div v-for="(event, i) in $store.state.calender.calenderEvent" :key="i">
          <v-list-item
            v-if="moment(event.start_time).format('YYYY-MM-DD') === date"
            :value="event.event_id"
            :class="$style.outlined"
            class="pl-2 pr-0"
          >
            <v-list-item-content v-if="!event.cancelApp">
              <v-row class="ma-0">
                <v-col class="px-0 py-0">
                  <v-list-item-subtitle
                    :class="$style.headeCard"
                    class="text-capitalize"
                    >{{ event.appointment_time }}
                  </v-list-item-subtitle>
                  <div class="d-flex flex-row">
                    <div
                      class="text-capitalize"
                      :class="$style.calaenderActiveText"
                    >
                      <p class="text-truncate" :class="$style.lineHeight">{{
                        event.provider_name
                      }}</p>
                    </div>
                    <v-spacer></v-spacer>
                    <div
                      class="text-caption mr-2 text-right"
                      :class="$style.calaenderActiveText"
                    >
                      {{ moment(event.start_time).fromNow() }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-content v-if="event.cancelApp">
              <v-row class="ma-0">
                <v-col class="px-0 py-0">
                  <v-list-item-subtitle
                    :class="$style.headeCard"
                    class="text-capitalize"
                  >
                    Confirm Cancellation
                  </v-list-item-subtitle>
                  <div class="d-flex flex-row">
                    <div class="">
                      <p class="text-truncate"
                        >Are you sure you want to cancel <br />
                        this meeting?</p
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <div v-if="moment(event.start_time).format('YYYY-MM-DD') === date">
            <div class="d-flex flex-row" :class="$style.cardCustom">
              <div>
                <a :class="$style.ancolButton" @click="showEvent(event)"
                  >Details</a
                >
              </div>
            </div>
          </div>
          <transition name="fade">
            <div
              v-if="
                selectedItem === event.event_id &&
                  moment(event.start_time).format('YYYY-MM-DD') === date
              "
              class="pa-0 ma-0"
            >
              <v-card
                width="1000"
                :color="event.color + ' lighten-4'"
                class="mb-2"
              >
                <!-- color="grey lighten-4" -->
                <v-toolbar :color="event.color + ' lighten-2'" flat>
                  <!-- color="grey lighten-2" -->
                  <v-toolbar-title class="text-capitalize">
                    <h5>{{ event.type.name }}</h5>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-1"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="$router.push('/calendar/' + event.event_id)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View Event</span>
                  </v-tooltip>
                  <v-tooltip v-if="!event.is_recurring" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-1"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $router.push('/calendar/' + event.event_id + '/edit')
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Event</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-1"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="selectedItem = null"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Close</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-title class="text-capitalize">{{
                  event.title
                }}</v-card-title>
                <v-card-subtitle>{{
                  moment(event.start_time).calendar()
                }}</v-card-subtitle>
                <v-card-text>
                  <div v-if="event.description"
                    >Notes: {{ event.description }}</div
                  >
                </v-card-text>
              </v-card>
            </div>
          </transition>
        </div>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.calaenderActiveText {
  color: rgba(0, 0, 0, 0.87);
}

.outlined {
  pointer-events: none;
  border-top: 1px solid #ccc;
  border-radius: 0 !important;
}

.cardCustom {
  padding: 0 10px 10px;
  border-bottom: 1px solid #ccc;
}

.lineHeight {
  line-height: normal !important;
}

.cardCustomAncol {
  padding: 0 10px;
  margin-top: -10px;
}

.headeCard {
  padding: 10px 0;
  font-size: 16px !important;
  font-weight: bold !important;
}

.ancolButton {
  padding-right: 10px;
  font-size: 13px;
}

.ancolButtonBold {
  padding-right: 10px;
  font-size: 13px;
  font-weight: bold;
}

.spanSeperator {
  color: #ccc;
}

.disableAncolButton {
  padding-right: 10px;
  font-size: 13px;
  color: #ccc !important;
  pointer-events: none;
}

.text-truncate {
  line-height: 21px !important;
}
</style>
